import clsx from 'clsx';
// icons
import { Zap } from 'lucide-react';
// components
import type { IAct } from '@newo/api/gateway';
import Message from '@/modules/Chat/components/Message';
import SessionEnded from '@/modules/Chat/components/EventMessage/components/SessionEnded';
// utils
import { formatDate } from '@/utils/format.ts';
import { DATE_FORMAT } from '@/constants';
// assets
import styles from '@/modules/Chat/components/EventMessage/EventMessage.module.css';

interface EventMessageProps {
    className?: string;
    act: IAct;
}

const EventMessage = ({ className, act }: EventMessageProps) => {
    const prettyName = act.reference_idn.replaceAll('_', ' ').toLowerCase();

    let content;

    if (act.reference_idn === 'session_ended') {
        content = (
            <SessionEnded
                args={act.arguments}
                externalId={act.external_id}
                integrationIdn={act.integration_idn}
                recordings={act.recordings}
            />
        );
    }

    return (
        <Message.Root className={clsx(styles.message, className)}>
            <header className={styles.header}>
                <Zap />
                <span>{prettyName}</span>
            </header>
            <section>{content}</section>
            <footer className={styles.footer}>
                {formatDate(act.datetime, DATE_FORMAT.FULL_12H)}
            </footer>
        </Message.Root>
    );
};

export default EventMessage;
